import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getINTEGPAYLOADSELECTORTableStructure";
export const UPDATE_TABLE_DATA = "updateINTEGPAYLOADSELECTORTableData";
export const EXPORT_TABLE_DATA = "exportINTEGPAYLOADSELECTORTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setINTEGPAYLOADSELECTORTableStructure";
export const SET_TABLE_DATA = "setINTEGPAYLOADSELECTORTableData";
export const SET_TABLE_FILTER = "setINTEGPAYLOADSELECTORTableFilters";
export const SET_TABLE_PAGE = "setINTEGPAYLOADSELECTORTablePage";
export const SET_TABLE_PER_PAGE = "setINTEGPAYLOADSELECTORTablePerPage";
export const SET_TABLE_SORT_BY = "setINTEGPAYLOADSELECTORTableSortBy";
export const SET_EXPORT_LINK = "setINTEGPAYLOADSELECTORExportLink";
export const SET_INTEGRATION_ID = "setINTEGPAYLOADSELECTORIntegrationId";

const state = {
  // export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getINTEGPAYLOADSELECTORTableProperties(state) {
    return state.table_structure.properties;
  },
  getINTEGPAYLOADSELECTORTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getINTEGPAYLOADSELECTORTableState(state) {
    return state.table_state;
  },
  getINTEGPAYLOADSELECTORTableHeaders(state) {
    return state.table_structure.columns;
  },

  getINTEGPAYLOADSELECTORTableFilters(state) {
    return state.table_structure.filters;
  },

  getINTEGPAYLOADSELECTORTableData(state) {
    return state.table_data.data;
  },

  getINTEGPAYLOADSELECTORExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/validations/datahub/integration_payload_selectors",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        })
        .finally((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/validations/datahub/integration_payload_selectors/datatable",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .finally((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/validations/datahub/integration_payload_selectors_new/export",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },

  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PER_PAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORT_BY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
